import React, { FC, useContext } from 'react';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { PageNav } from '../../components/page-nav/PageNav';
import { enterpriseNav } from './enterpriseNav';
import { EnterpriseTopDecisions } from './EnterpriseTopDecisions';
import { EnterpriseHeader } from './header/EnterpriseHeader';
import { EnterpriseCases } from './EnterpriseCases';
import { EnterpriseRepresenting } from './EnterpriseRepresenting';
import { EnterpriseOpponentsAndEvolution } from './EnterpriseOpponentsAndEvolution';
import { Sticker } from '../../components/sticker/Sticker';
import { EnterpriseSubHeader } from './sub-header/EnterpriseSubHeader';
import { EnterpriseMobileBar } from './sub-header/EnterpriseMobileBar';
import { CustomToastContainer } from '../../components/toaster/CustomToastContainer';
import { PageContainer } from '../../components/page-container/PageContainer';
import { Page, PageLeft, PageCenter } from '../../components/page/Page';
import { getPageName } from '../../utils/pageName';
import { EnterpriseContext } from './EnterpriseContext';

export const EnterpriseMain: FC = () => {
  const { enterpriseInfos, experience } = useContext(EnterpriseContext);
  const { raisonSociale, enterpriseId } = enterpriseInfos;

  const allDecisionsLink = buildUrlWithParameters('/search', {
    q: encodeURIComponent(raisonSociale),
    chrono: true,
    eid: enterpriseId,
    sourcePage: getPageName(),
  });
  const hasEnterpriseCases =
    experience.domains.length > 0 ||
    experience.juridictions.length > 0 ||
    experience.villes.length > 0;
  return (
    <>
      <Sticker margin="enterprise-sub-header" anchor="add-watcher-enterprise">
        {({ isVisible }: { isVisible: boolean }) => (
          <EnterpriseSubHeader isVisible={isVisible} />
        )}
      </Sticker>
      <CustomToastContainer />
      <div className="entity">
        <PageContainer>
          <Page>
            <PageLeft>
              <PageNav outline={enterpriseNav} newNav />
            </PageLeft>
            <PageCenter>
              <EnterpriseHeader allDecisionsLink={allDecisionsLink} />
              <EnterpriseTopDecisions allDecisionsLink={allDecisionsLink} />
              {hasEnterpriseCases && <EnterpriseCases />}
              <EnterpriseRepresenting />
              <EnterpriseOpponentsAndEvolution />
            </PageCenter>
            <Sticker anchor="add-watcher-enterprise">
              {({ isVisible }: { isVisible: boolean }) => (
                <EnterpriseMobileBar isVisible={isVisible} />
              )}
            </Sticker>
          </Page>
        </PageContainer>
      </div>
    </>
  );
};
